import React from 'react';
import { CheckCircle2 } from 'lucide-react';

export const FeatureHighlights = () => {
    const features = [
        "Advanced Technology",
        "Experienced Team",
        "Pain-Free Treatment",
        "Emergency Care",
        "Easy Payment Options"
    ];

    return (
        <section id="about" className="py-12 bg-white">
            <div className="container mx-auto px-4">
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 font-body">
                    {features.map((feature, index) => (
                        <div key={index} className="bg-gray-50 p-4 md:p-6 rounded-2xl text-center flex flex-col items-center justify-center gap-3 hover:bg-black hover:text-white transition-all duration-300 group border border-gray-100">
                            <CheckCircle2 className="text-black group-hover:text-white w-5 h-5 transition-colors" />
                            <span className="text-black/80 group-hover:text-white font-semibold text-xs leading-tight tracking-wider uppercase">
                                {feature}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
